import { Component } from '@angular/core';

@Component({
  selector: 'app-pptx-pdf-content',
  imports: [],
  templateUrl: './pptx-pdf-content.component.html',
  styleUrl: './pptx-pdf-content.component.css'
})
export class PptxPdfContentComponent {

}
